import { useEffect, useState } from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import check_example from "./../../../../assets/images/check_example.png";
import axios from "../../../../axios";
import urls from "../../../../Utils/urls";
import FormBox from "../../../../components/FormBox/FormBox";
import {
  BlurWrapperWithSpan,
  SpinnerBlock,
} from "../../../../Utils/CustomComponent";
import { handleRoutingDetails, setSameDayPayment } from "../../../../store/reducers/achPaymentSlice";
import { useAbortController } from "../../../../hooks/useAbortController";
import PopupWrapper from "../../../../components/PopupWrapper";
import { ChequePaymentFormSchemaOptions } from "../../../../Utils/formOptions";
import useBorowerLoanDetail from "../../../../hooks/useBorowerLoanDetail";
import MultipleFormBoxComp from "../../../../components/FormBox/MultipleFormBoxComp";
import classes from "../AllLoans/LoanDetails.module.css";
import CustomBreadCrumbs from "../../../../components/CustomBreadCrumbs";
import { Button } from "react-bootstrap";
import AddAccountModal from "./AddAccountModal";
import DeleteAccountModaal from "./DeleteAccountModal";

const SameDayPayment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm(ChequePaymentFormSchemaOptions);
  const [showPopup, setShowPopup] = useState(false);
  const [showBankInfo, setShowBankInfo] = useState(false);
  const [achInfo, setAchInfo] = useState({});
  const [routingDetails, setRoutingDetails] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  const [loader, setLoader] = useState(false);
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const accountId = useSelector((state) => state.account.lenderId);
  const paymentAccounts = useSelector(
    (state) => state.account.paymentAccounts.data
  );

  const [selectedPaymentAccount, setSelectedPaymentAccount] = useState(
    paymentAccounts?.[0]
  );
  const routingNumber = watch("routingNumber");
  const accountNumber = watch("accountNumber");
  const verifyAccountNumber = watch("verifyAccountNumber");
  const { signal } = useAbortController();
  // const location = useLocation();
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const { loanDetails } = useBorowerLoanDetail(accountId);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      try {
        setDisableBtn(true);
        const getData = await axios.get(
          urls.borrower.getRoutingNumberValidation(routingNumber),
          { signal }
        );

        if (getData?.data.code == 404) {
          setError("routingNumber", {
            type: "custom",
            message: "Invalid routing number",
          });
          setShowRoutingNumberVaildatorPopup(true);
          setIsRoutingNumberVerified(false);
          setRoutingDetails({});
          dispatch(handleRoutingDetails({}));
          // setDisableBtn(true);
        } else if (getData?.data.code == 200) {
          setIsRoutingNumberVerified(true);
          setRoutingDetails(getData.data);
          dispatch(handleRoutingDetails(getData.data));
          setDisableBtn(false);
          clearErrors("routingNumber");
        }
        return getData.data;
      } catch (error) {
        setError("routingNumber", {
          type: "custom",
          message: "Routing validation failed",
        });
        setRoutingDetails({});
        dispatch(handleRoutingDetails({}));
        setDisableBtn(true);
      }
    };
    if (routingNumber?.length === 9) {
      handleRoutingNumberValidation();
    } else if (routingNumber?.length && routingNumber?.length !== 9) {
      setError("routingNumber", {
        type: "custom",
        message: "Routing number must be 9 digits",
      });
      setRoutingDetails({});
      dispatch(handleRoutingDetails({}));
      setDisableBtn(true);
    }
  }, [routingNumber, dispatch]);

  useEffect(() => {
    setLoader(true);
    const fetchData = async () => {
      const res = await axios.get(
        urls.borrower.getPaymentsLoanAchSameDayInfo(accountId),
        { signal }
      );

      let data = res.data[0][0];
      setAchInfo(data);
      setValue("bankAccountName", data?.ACH_IndividualName);
      setValue("payTo", "Superior Loan Servicing");
      setValue("amount", data?.ACH_DebitAmount);
      setValue("routingNumber", data?.ACH_RoutingNumber);
      setValue("accountNumber", data?.ACH_AccountNumber);
      setValue("verifyAccountNumber", data?.ACH_AccountNumber);
      setLoader(false);
    };
    fetchData();
  }, [accountId, setValue]);

  const toggleBankInfo = () => {
    setShowBankInfo(!showBankInfo);
  };

  const onSubmit = (data) => {
    if (accountNumber && verifyAccountNumber) {
      if (accountNumber !== verifyAccountNumber) {
        setError("verifyAccountNumber", {
          type: "custom",
          message: "Account numbers do not match",
        });
      } else {
        data.isRoutingNumberVerified = isRoutingNumberVerified;
        dispatch(
          setSameDayPayment({
            ...data,
            loan_account_number: achInfo?.loan_account_number,
            bankName: routingDetails.customer_name,
            bankAddress: routingDetails.address,
            bankCity: routingDetails.city,
            bankState: routingDetails.state,
            bankZip: routingDetails.zip,
            bankTelephone: routingDetails.telephone,
          })
        );
        setShowPopup(true);
      }
    }
  };

  function handleAccountChange(e) {
    setSelectedPaymentAccount(e);
  }

  return (
    <>
      <div className="p-3 pb-0  mt-1">
        <CustomBreadCrumbs
          crumbs={[
            { title: "Loan Details", link: "/loan-details-borrower" },
            { title: "Same Day Payment" },
          ]}
        />
      </div>
      {loader ? (
        <div style={{ margin: "130px" }}>
          <h2 className="d-flex">
            {/* Same Day Payment */}
            <SpinnerBlock />
          </h2>
        </div>
      ) : (
        <div className="mt-5 p-5" style={{ textAlign: "start" }}>
          <h1 className="border-bottom mb-5">Same Day Payment</h1>
          <p>
            Please enter your information below to perform a same day payment.
            There is a charge of $30 for this service. If you don't need a same
            day payment, you can choose a next day ACH payment instead. “Same
            Day Payments” must be received by 5PM (PT) on each business day
            (excludes holidays).​
          </p>
          <div className="d-flex justify-content-end gap-4 p-5">
            <div className="w-25">
              <Select
                options={paymentAccounts}
                value={selectedPaymentAccount}
                onChange={handleAccountChange}
                classNamePrefix="select"
              />
            </div>
            <div>
              <Button
                className="btn btn-primary text-white"
                // variant="outline-primary"
                onClick={() => {
                  setShowAccountForm(true);
                }}
              >
                + Add Bank Account
              </Button>
            </div>
            <div>
              <Button
                // className=" text-white"
                variant="outline-error"
                onClick={() => {
                  setShowDeleteForm(true);
                }}
              >
                Delete Bank Account
              </Button>
            </div>
          </div>
          <h1 className="border-bottom mb-5">
            Loan No.: {achInfo?.loan_account_number} -{" "}
            {/* {achInfo?.ACH_IndividualName} Address: {location?.state} */}
            {achInfo?.ACH_IndividualName} Address:{" "}
            {loanDetails?.loanTerm?.loanheader2?.split?.(":")?.[1]}
          </h1>
          <div className="p-5 border border-5">
            <h4
              className="p-5"
              style={{ backgroundColor: "#f5f5f5", borderRadius: "6px" }}
            >
              Payment Info
            </h4>
            {/* <FormBox
              options={firstFormArr}
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            /> */}
            <div>
              {firstFormArr.map((data, index) => (
                <MultipleFormBoxComp
                  key={index}
                  options={data.arr}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />
              ))}
            </div>
          </div>
          <div>
            <button
              type="button"
              className="mt-5 btn text-white fw-bold btn btn-primary"
              onClick={toggleBankInfo}
            >
              <BlurWrapperWithSpan>
                {achInfo?.ACH_IndividualName}
              </BlurWrapperWithSpan>{" "}
              - Checking account ending in{" "}
              <BlurWrapperWithSpan>
                {achInfo?.ACH_AccountNumber?.substring(
                  achInfo?.ACH_AccountNumber?.length - 4
                )}
              </BlurWrapperWithSpan>
            </button>
            {showBankInfo && (
              <div className="p-5 border border-5">
                <img
                  width={isLargeDevice ? "650" : "450"}
                  src={check_example}
                  alt="The lower-left of a bank check, indicating the routing number is typically found on the bottom left and the account number on the bottom center. "
                />
                <BlurWrapperWithSpan>
                  <div style={{ color: "green" }}>
                    {routingDetails.customer_name} - {routingDetails.city},{" "}
                    {routingDetails.state} {routingDetails.zip}{" "}
                  </div>
                </BlurWrapperWithSpan>
                <FormBox
                  options={seconfFormArr}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />
              </div>
            )}
          </div>
          <div>
            <button
              type="button"
              className="mt-5 btn btn-primary me-5"
              style={{ width: "fit-content" }}
              onClick={() => navigate("/ach-payment")}
            >
              Cancel
            </button>
            <button
              type="button"
              className="mt-5 btn btn-primary"
              style={{ width: "fit-content" }}
              disabled={disableBtn}
              onClick={handleSubmit(onSubmit)}
            >
              Preview
            </button>
            <PopupWrapper
              // backdrop="static"
              extraClass={`${isLargeDevice ? "width-800" : ""}`}
              title={
                <h2 className="p-4 font-weight-bold text-dark">Charges</h2>
              }
              Component={
                <div>
                  {" "}
                  There is a charge of $30 for this service. If you don't need a
                  same day payment, you can choose a next day ACH payment
                  instead. “Same Day Payments” must be received by 5PM (PT) on
                  each business day (excludes holidays).​ Please review your
                  submission. Your submission is not complete until you press
                  the "Submit" button!
                  {/* <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-secondary mt-5 right"
                      onClick={() => {
                        setShowPopup(false);
                        navigate("/preview-check");
                      }}
                    >
                      Close
                    </button>
                  </div> */}
                </div>
              }
              toShow={showPopup}
              closeEventHandler={() => {
                setShowPopup(false);
                navigate("/preview-check");
              }}
            />
          </div>
        </div>
      )}
      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisableBtn}
        routingNumber={routingNumber}
      />

      <AddAccountModal show={showAccountForm} setShow={setShowAccountForm} />
      <DeleteAccountModaal
        show={showDeleteForm}
        setShow={setShowDeleteForm}
        AccountSelect={
          <Select
            options={paymentAccounts}
            value={selectedPaymentAccount}
            onChange={handleAccountChange}
            classNamePrefix="select"
          />
        }
        selectedPaymentAccount={selectedPaymentAccount}
      />
    </>
  );
};

export default SameDayPayment;
// const firstFormArr = [
//   {
//     title: "Name of Bank Account *",
//     field: "bankAccountName",
//     type: "text",
//   },
//   {
//     title: "Address *",
//     field: "address",
//     type: "textarea",
//   },
//   {
//     title: "City, State, Zip *",
//     field: "cityStateZip",
//     type: "textarea",
//   },
//   {
//     title: "Pay to *",
//     field: "payTo",
//     type: "text",
//   },
//   {
//     title: "Amount *",
//     field: "amount",
//     type: "text",
//   },
//   {
//     title: "Memo",
//     field: "memo",
//     type: "text",
//   },
// ];

const firstFormArr = [
  {
    field: "",
    arr: [
      {
        section: "",
        className: "col-5",
        arr: [
          {
            title: "Name of Bank Account *",
            field: "bankAccountName",
            type: "text",
          },
          {
            title: "Address *",
            field: "address",
            type: "textarea",
          },
          {
            title: "City, State, Zip *",
            field: "cityStateZip",
            type: "textarea",
          },
        ],
      },
      {
        section: "",
        className: "col-5",
        arr: [
          {
            title: "Pay to *",
            field: "payTo",
            type: "text",
          },
          {
            title: "Amount *",
            field: "amount",
            type: "text",
          },
          {
            title: "Memo",
            field: "memo",
            type: "text",
          },
        ],
      },
    ],
  },
];
const seconfFormArr = [
  {
    title: "Routing Number *",
    field: "routingNumber",
    type: "text",
    blur: true,
  },
  {
    title: "Account Number *",
    field: "accountNumber",
    type: "text",
    blur: true,
  },
  {
    title: "Account Number Verify *",
    field: "verifyAccountNumber",
    type: "text",
    blur: true,
  },
];

export const RoutingNumberValidator = ({
  show,
  setShow,
  clearErrors,
  setDisableBtn,
  routingNumber,
}) => {
  function validateRoutingNumber() {
    setShow(false);
    if (routingNumber?.length === 9) {
      clearErrors("routingNumber");
      setDisableBtn(false);
    } else {
      setShow(false);
      setDisableBtn(true);
    }
  }

  function invalidateRoutingNumber() {
    setShow(false);
    setDisableBtn(true);
  }

  return (
    <PopupWrapper
      title=""
      extraClass="width-800"
      backdrop="static"
      Component={
        <div>
          <p className="fw-bold text-center">
            This routing number hasn't been validated. Do you still wish to
            proceed with it?
          </p>
          <div className="d-flex justify-content-end gap-5 mb-3">
            <button
              className="btn btn-primary"
              onClick={() => validateRoutingNumber()}
            >
              Yes
            </button>
            <button
              className="btn btn-primary"
              onClick={() => invalidateRoutingNumber()}
            >
              No
            </button>
          </div>
        </div>
      }
      toShow={show}
      closeEventHandler={() => setShow(false)}
    />
  );
};
